'use client';
import { Image } from '@akinon/next/components';
import { Product } from '@akinon/next/types';
import { Icon } from '@theme/components/icon';
import { removeFromCompare } from '@theme/redux/reducers/compare';
import { useAppDispatch } from '@akinon/next/redux/hooks';
import { useGetProductByPkQuery } from '@akinon/next/data/client/product';
import { useEffect, useState } from 'react';

export default function ProductCard({
  productPk
}: {
  productPk: Product['pk'];
}) {
  const dispatch = useAppDispatch();
  const [isMounted, setIsMounted] = useState(false);
  const { data, isLoading, isSuccess } = useGetProductByPkQuery(productPk);
  const { product } = data || {};

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) {
    return null;
  }

  return (
    <>
      {isLoading && isMounted && (
        <div className="w-16 flex flex-col items-start animate-pulse">
          <div className="w-16 h-16 bg-gray-200 rounded"></div>
          <div className="w-14 h-3 bg-gray-200 rounded mt-2"></div>
          <div className="w-12 h-3 bg-gray-200 rounded mt-1"></div>
        </div>
      )}
      {isSuccess && isMounted && (
        <div
          key={product?.pk}
          className="flex flex-col items-start w-16 relative group cursor-pointer"
        >
          <Image
            src={product?.productimage_set[0]?.image || ''}
            width={64}
            height={64}
            alt={product?.name}
            className="w-16 h-16 lg:w-full lg:h-full object-cover rounded"
          />
          <span className="w-full text-sm leading-tight line-clamp-2 break-words">
            {product?.name}
          </span>
          <button
            className="absolute -top-2 -right-2 bg-gray-250 rounded-full block"
            onClick={() => product && dispatch(removeFromCompare(product))}
            aria-label={`Remove ${product?.name} from compare`}
          >
            <Icon name="close" size={16} />
          </button>
        </div>
      )}
    </>
  );
}
